import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { api, setToken, saveUser, safeInternalPath } from "../api";
import i18n from "../i18n";
import { toast } from "sonner";

export default function Login() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [params] = useSearchParams();
  // Ritorno post-login: solo percorsi relativi interni, mai redirect esterni
  const safeNext = safeInternalPath(params.get("next"));
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      const { data } = await api.post("/auth/login", f);
      if (data.email_confirmation_required) { toast.info("Conferma la tua email"); nav(`/confirm-email?email=${encodeURIComponent(data.email)}`); return; }
      setToken(data.token); saveUser(data.user); toast.success("Accesso effettuato");
      if (data.user.language) { localStorage.setItem("lang", data.user.language); i18n.changeLanguage(data.user.language); }
      if (data.user.must_change_password) { nav("/settings?force=1"); return; }
      // Rientro automatico nel videoconsulto attivo: priorita' sui redirect non critici (incluso completamento profilo).
      try { const { data: av } = await api.get("/video/active"); if (av.active) { nav(`/video/${av.active.id}?resume=1`); return; } } catch {}
      // Accettazioni legali pendenti: prioritarie sui redirect di destinazione (dopo la sicurezza e il rientro video).
      try { const { data: lp } = await api.get("/legal/pending"); if (lp.pending && lp.pending.length) { nav("/legal/consent"); return; } } catch {}
      if (data.user.profile_complete === false) { nav("/settings?complete=1"); return; }
      if (safeNext) { nav(safeNext); return; }
      // Fallback server-side one-shot: destinazione /clinica collegata a un invito
      // attivato, ridata dal server (sopravvive all'intervallo approvazione/login).
      if (["professional", "organization"].includes(data.user.role)) {
        try { const { data: rt } = await api.get("/invite/redirect-target"); if (rt?.patient_id) { nav(`/clinica/${rt.patient_id}`); return; } } catch {}
      }
      if (data.user.role === "admin") nav("/admin");
      else if (data.user.role === "professional") nav(`/professionals/${data.user.id}`);
      else if (data.user.role === "organization") nav(`/organizations/${data.user.id}`);
      else nav("/feed");
    } catch (err) { const m = err.response?.data?.detail; const msg = typeof m === "string" ? m : "Errore login"; setErr(msg); toast.error(msg); }
  };
  return (
    <Layout><div className="yp-container max-w-md py-12">
      <h1 className="text-3xl font-bold mb-2">{t("auth.login_title")}</h1>
      <p className="text-sm text-slate-500 mb-6">{t("auth.not_recovery")}</p>
      <form onSubmit={submit} className="space-y-4 yp-card p-6" data-testid="login-form">
        <input className="yp-input" placeholder={t("common.email")} type="email" value={f.email} onChange={e => setF({...f, email:e.target.value})} data-testid="login-email" required />
        <input className="yp-input" placeholder={t("common.password")} type="password" value={f.password} onChange={e => setF({...f, password:e.target.value})} data-testid="login-password" required />
        <button className="yp-btn yp-btn-primary w-full" type="submit" data-testid="login-submit">{t("nav.login")}</button>
        {err && <div role="alert" data-testid="login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2">{err}</div>}
      </form>
      <div className="mt-4 text-sm flex justify-between">
        <Link to="/register/user" className="yp-link" data-testid="link-register-user">{t("home.cta_user")}</Link>
        <Link to="/register/pro" className="yp-link" data-testid="link-register-pro">{t("home.cta_pro")}</Link>
        <Link to="/register/org" className="yp-link" data-testid="link-register-org">{t("home.cta_org")}</Link>
      </div>
    </div></Layout>
  );
}
